import React from 'react';
export function Hero() {
  return <div className="mb-8" data-id="element-82">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6 font-sans" data-id="element-83">
        I Woke Up on My Kitchen Floor with Paramedics Over Me—
        <span className="bg-[#FEF3C7] px-1" data-id="element-84">
          I'd Had a Seizure Trying to Quit Drinking Alone
        </span>
      </h1>
    </div>;
}